import { HelmetDexteel } from "@dexteel/mesf-core";
import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { TableCategories } from "./components/TableCategories";
import { DelayCategory } from "./models/CatalogCategory";
import { getCatalogCategories } from "./repositories/CatalogCategoriesRepository";

type useCategoriesProps = {
	assetId?: number;
	includeInactives?: boolean;
	onError?: (error: Error) => void;
};

export const useCategories = ({
	assetId,
	includeInactives = false,
	onError,
}: useCategoriesProps) => {
	return useQuery<DelayCategory[], Error>({
		queryKey: ["delayCategories", assetId, includeInactives],
		queryFn: ({ signal }) => getCatalogCategories({ includeInactives }, signal),
		onError: onError,
	});
};

export const CatalogCategoriesPage = () => {
	const { categoryId } = useParams();

	return (
		<>
			<HelmetDexteel title="Delay Categories" />
			<TableCategories categoryId={categoryId} />
		</>
	);
};
